
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppCommonUser} from "@/models/app/common/User";
import {AppCommonDiagnosticCategory} from "@/models/app/common/diagnostic-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorNavigationVue from "@/components/administrator/navigation.vue";
import AdministratorDiagnosticsNavigationVue from "@/components/administrator/diagnostics/navigation.vue";
import AppAdministratorDiagnosticsRootFilterIndexVue from "@/views/app/administrator/diagnostics/root/filter/index.vue";
import AppAdministratorDiagnosticsRootListIndexVue from "@/views/app/administrator/diagnostics/root/list/index.vue";

// Services
import {getRequest, postRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AdministratorNavigationVue,
    AdministratorDiagnosticsNavigationVue,
    AppAdministratorDiagnosticsRootFilterIndexVue,
    AppAdministratorDiagnosticsRootListIndexVue,
  },
})
export default class AppAdministratorDiagnosticsRootIndexVue extends Vue {
  isLoading: boolean | null = false;

  players: Array<AppCommonUser> = [];
  diagnosticCategories: Array<AppCommonDiagnosticCategory> = [];

  $refs!: {
    AppAdministratorDiagnosticsRootListIndexVue: any;
  };

  getDiagnosticsByFilter(formData: any): void {
    this.$refs.AppAdministratorDiagnosticsRootListIndexVue.getDiagnostics(formData);
  }

  async getPlayers(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/utility/organization-members`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
        role: "player",
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.players = r.data;
      }
    });
    this.isLoading = false;
  }

  async getDiagnosticCategories(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/utility/diagnostic-categories`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.diagnosticCategories = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getPlayers();
    await this.getDiagnosticCategories();
  }
}
